// Trigger & element must be inside container in DOM
const containerSelectorClass = "js-showmore";
const elementSelectorClass = "js-showmore-element";
// Trigger element must have "data-read-more" & "data-read-less" attributes with content or sign for proper trigger content appearance
const triggerSelectorClass = "js-showmore-trigger";
// State input must be first child of container in DOM
const stateSelectorClass = "js-showmore-state";
const activeClass = "is-active";
const elObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.target.isConnected) {
            const elVisibleHeight = Math.round(entry.contentRect.height);
            const elFullHeight = entry.target.scrollHeight;
            const isElementTruncated = elVisibleHeight < elFullHeight;
            const containerEl = entry.target.parentElement;
            const triggerEl = containerEl === null || containerEl === void 0 ? void 0 : containerEl.querySelector(`.${triggerSelectorClass}`);
            const stateEl = containerEl === null || containerEl === void 0 ? void 0 : containerEl.querySelector(`.${stateSelectorClass}`);
            const isContainerShowMore = containerEl === null || containerEl === void 0 ? void 0 : containerEl.classList.contains(containerSelectorClass);
            const isElementExpanded = stateEl.checked;
            if (isContainerShowMore && isElementTruncated) {
                triggerEl === null || triggerEl === void 0 ? void 0 : triggerEl.classList.add(activeClass);
            }
            else if (!isElementExpanded) {
                // Make sure there is not any redundant active trigger after recalculating
                triggerEl === null || triggerEl === void 0 ? void 0 : triggerEl.classList.remove(activeClass);
            }
        }
    });
});
function handleShowMoreElements() {
    const elArray = document.querySelectorAll(`.${elementSelectorClass}`);
    elArray.forEach((el) => {
        initElement(el);
    });
}
export function initElement(el) {
    if (el) {
        console.debug("init showMore ", el);
        elObserver.observe(el, { box: "border-box" });
    }
}
function initShowMore() {
    handleShowMoreElements();
}
/**
 * Show More.
 */
export default {
    init: function () {
        initShowMore();
    },
};
